import { createSelector } from 'reselect';
import { AppState } from '../rootReducer';

const getBranchList = (state: AppState) => state.branch.branchList;
const getBranchCount = (state: AppState) => state.branch.total;
const getBranchLoading = (state: AppState) => state.branch.loading;
const getBranchError = (state: AppState) => state.branch.error;

export const branchListSelector = createSelector(getBranchList, (branchList) => branchList);
export const branchCountSelector = createSelector(getBranchCount, (total) => total);
export const branchLoadingSelector = createSelector(getBranchLoading, (loading) => loading);
export const branchErrorSelector = createSelector(getBranchError, (error) => error);
